<script>
    export default {
        methods: {
            async search() {
                this.$store.dispatch('UPDATE_USERS');
            },
            async clear() {
                this.$store.commit('USER_SEARCH_UPDATE',{
                    fieldName: 'id', fieldValue: null
                });
                this.$store.commit('USER_SEARCH_UPDATE',{
                    fieldName: 'email', fieldValue: null
                });
                this.$store.commit('USER_SEARCH_UPDATE',{
                    fieldName: 'is_active', fieldValue: 'all'
                });
                this.$store.commit('USER_SEARCH_UPDATE',{
                    fieldName: 'user_role_id', fieldValue: 'all'
                });
            },
            async close() {
                this.$store.commit('IS_SHOW_USER_SEARCH', false);
            }
        }
    }
</script>


<template>
    <div>
        <button
            class="button_blue_100"
            @click="search"
        >Search</button>
        <button
            class="button_blue_100 ml_10"
            @click="clear"
        >Clear</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>